import Link from 'next/link';
import { AnchorHTMLAttributes, MouseEventHandler } from 'react';

import ChevronIcon from '@/fo/icons/base/icons/chevron.svg';
import type { CatalogTheme } from '@/fo/util/theme';

import { styles } from './PaginationArrow.styles';

interface PaginationArrowProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  direction: 'left' | 'right';
  href: string;
  disabled?: boolean;
  disabledNavigation?: boolean;
  theme?: CatalogTheme;
}

export function PaginationArrow({
  direction,
  disabled,
  href,
  disabledNavigation,
  theme = 'default',
  onClick,
  ...props
}: PaginationArrowProps) {
  const slots = styles({ disabled, left: direction === 'left', theme });

  const handleClick: MouseEventHandler<HTMLAnchorElement> = (event) => {
    if (disabledNavigation) {
      event.preventDefault();
    }

    onClick?.(event);
  };

  return (
    <Link
      className={slots.base()}
      href={href}
      onClick={handleClick}
      {...props}
    >
      <div className={slots.icon()}>
        <ChevronIcon className={slots.arrow()} />
      </div>
    </Link>
  );
}
